import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CursosPage = lazy(() => import('../pages/cursos/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const RedesPage = lazy(() => import('../pages/redes/page'));
const SuportePage = lazy(() => import('../pages/suporte/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/cursos',
    element: <CursosPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/redes',
    element: <RedesPage />,
  },
  {
    path: '/suporte',
    element: <SuportePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
